"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCart = fetchCart;
exports.updateCart = updateCart;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
// Shopify doc link: https://shopify.dev/docs/api/ajax/reference/cart#get-locale-cart-js
function fetchCart() {
  return _fetchCart.apply(this, arguments);
} // Shopify doc link: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
function _fetchCart() {
  _fetchCart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch('/cart.js');
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          return _context.abrupt("return", _context.sent);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          console.error("Error fetching cart:", _context.t0);
          return _context.abrupt("return", {
            items: []
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _fetchCart.apply(this, arguments);
}
function updateCart(_x, _x2) {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(variantId, quantity) {
    var properties,
      response,
      _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          properties = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _context2.prev = 1;
          _context2.next = 4;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              properties: properties
            })
          });
        case 4:
          response = _context2.sent;
          _context2.next = 7;
          return response.json();
        case 7:
          return _context2.abrupt("return", _context2.sent);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](1);
          console.error("Error updating cart:", _context2.t0);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return _updateCart.apply(this, arguments);
}
//# sourceMappingURL=cart.js.map
